import { render } from "./UserDataForm.vue?vue&type=template&id=f93295b2&ts=true"
import script from "./UserDataForm.vue?vue&type=script&lang=ts"
export * from "./UserDataForm.vue?vue&type=script&lang=ts"

import exportComponent from "/jenkins-tmp/workspace/Recruiting-PP6/Oidcserver/development@2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__